import compact from 'lodash/compact'

import { Nullable } from '@shared/models/types/primary'

export const handleUserFullName = (
  fallback: string,
  firstNameBasic?: Nullable<string>,
  lastNameBasic?: Nullable<string>,
  firstNameSecondary?: Nullable<string>,
  lastNameSecondary?: Nullable<string>
): string => {
  const values = [firstNameBasic, lastNameBasic]

  const isEmpty = values.every((item) => !item)

  if (isEmpty) {
    if (firstNameSecondary || lastNameSecondary) {
      return handleUserFullName(fallback, firstNameSecondary, lastNameSecondary)
    }

    return fallback
  }

  const isPartiallyEmpty = compact(values).length === 1

  if (isPartiallyEmpty) {
    return String(compact(values))
  }

  return `${firstNameBasic} ${lastNameBasic}`
}

export const formatUserInitials = (firstName = '', lastName = ''): string => {
  return [firstName?.trim().charAt(0), lastName?.trim().charAt(0)]
    .filter(Boolean)
    .join('')
}
